import React from "react";
import { Receipt, X, XCircle } from "lucide-react";
import { fmtPrice, fmtSigned } from "../../lib/format";

export default function PositionsTable({ snapshot, onClose, onCloseAll, readOnly }) {
  const positions = snapshot?.positions || [];
  const currency = snapshot?.account?.currency || "EUR";
  const live = snapshot?.liveEnabled;

  return (
    <div id="posizioni" data-testid="active-positions-table" className="panel overflow-hidden float-in">
      <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
        <div>
          <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
            <span className="w-6 h-6 rounded-md grid place-items-center bg-amber-500/15 text-amber-400">
              <Receipt size={13} />
            </span>
            Posizioni Attive
          </div>
          <p className="text-[10px] text-slate-500 mt-1">Gestite dal motore di esecuzione automatico</p>
        </div>
        <div className="flex items-center gap-2">
          <span
            className={`text-[9px] font-mono font-bold px-2 py-1 rounded ${
              live ? "bg-amber-500/15 text-amber-400" : "bg-sky-500/15 text-sky-400"
            }`}
          >
            {live ? "LIVE GUARDED" : "PAPER PREVIEW"}
          </span>
          {positions.length > 0 && (
            <button
              data-testid="close-all-positions-button"
              onClick={onCloseAll}
              disabled={readOnly}
              className="flex items-center gap-1.5 text-[10px] px-2.5 py-1.5 rounded-md bg-rose-500/10 border border-rose-500/25 text-rose-300 hover:bg-rose-500/20 transition-colors disabled:opacity-40"
            >
              <XCircle size={12} /> Chiudi tutto
            </button>
          )}
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse min-w-[720px]">
          <thead>
            <tr>
              {["Strumento", "Tipo", "Apertura", "SL", "TP", "P&L", ""].map((h, i) => (
                <th
                  key={i}
                  className="text-[9px] font-semibold uppercase tracking-wider text-slate-500 text-left px-4 py-3"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {positions.length === 0 ? (
              <tr>
                <td colSpan={7} className="text-center text-slate-500 text-[12px] py-10">
                  Nessuna posizione XAUUSD aperta
                </td>
              </tr>
            ) : (
              positions.map((p) => {
                const buy = String(p.side).toUpperCase() === "BUY";
                const profit = Number(p.profit || 0);
                return (
                  <tr key={p.positionId} className="border-t border-white/8 hover:bg-white/[0.02]">
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2.5 text-[12px] font-semibold">
                        <span className="w-6 h-6 rounded-md grid place-items-center bg-amber-300 text-[#0B0E17] text-[9px] font-black">
                          AU
                        </span>
                        <div className="leading-tight">
                          XAUUSD
                          <span className="block text-[9px] text-slate-500 font-normal font-mono">
                            #{p.positionId}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`text-[9px] font-mono font-bold px-2 py-1 rounded ${
                          buy ? "bg-emerald-500/12 text-emerald-400" : "bg-rose-500/12 text-rose-400"
                        }`}
                      >
                        {buy ? "BUY" : "SELL"} {Number(p.volume).toFixed(2)}
                      </span>
                    </td>
                    <td className="px-4 py-3 font-mono text-[11px]">
                      {fmtPrice(p.priceOpen)}
                      <span className="block text-[9px] text-slate-500">live {fmtPrice(p.priceCurrent)}</span>
                    </td>
                    <td className="px-4 py-3 font-mono text-[11px] text-rose-300/80">{fmtPrice(p.sl)}</td>
                    <td className="px-4 py-3 font-mono text-[11px] text-emerald-300/80">{fmtPrice(p.tp)}</td>
                    <td
                      className={`px-4 py-3 font-mono text-[12px] font-bold ${
                        profit >= 0 ? "text-emerald-400" : "text-rose-400"
                      }`}
                    >
                      {fmtSigned(profit, currency)}
                    </td>
                    <td className="px-4 py-3 text-right">
                      <button
                        data-testid={`close-position-button-${p.positionId}`}
                        onClick={() => onClose(p.positionId)}
                        disabled={readOnly}
                        className="w-7 h-7 rounded-md grid place-items-center text-slate-500 hover:text-rose-400 hover:bg-rose-500/10 transition-colors disabled:opacity-30"
                        aria-label={`Chiudi posizione ${p.positionId}`}
                      >
                        <X size={15} />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
